import type { FaireProductEntity } from "../../entity_types/product";

export const p_s6ezf997cr: FaireProductEntity = {
  token: "p_s6ezf997cr",
  type: "product",
  name: "birds paintable watercolor notecard set",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/5fcb2006d08e9b31e590e38638b0fe96173c9e51a2ccb06c13ba5010d1e2a542.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2978990119bef83207e1e37552156a8e59a989aa75ac9fc63d46641c3d18d4ed.jpeg",
    "https://cdn.faire.com/fastly/897be30a7ce0842645c4463275d13ec8de4907286e5ed8bacaac3eb645977851.jpeg",
    "https://cdn.faire.com/fastly/5f2e1f1674671b42de2640ad9130a67b8545e773619b541936502e75523ce748.jpeg",
    "https://cdn.faire.com/fastly/5dfccab79b64eb900bb29b68c960c3ba3dbff5b1d2c67eebfc894a6853718524.jpeg",
    "https://cdn.faire.com/fastly/dddc5b430a93f30ee8691243c5c47d98d5f17794051d3c60a081d559320aacf2.jpeg",
    "https://cdn.faire.com/fastly/9e653998d28289a268801acbd24728560caff89bcb64344c093da9c38e93cc69.jpeg",
    "https://cdn.faire.com/fastly/4852f81ae4b1c3585408c2997b9e958040863065588c16d12d844e100bab157f.jpeg",
    "https://cdn.faire.com/fastly/986244a539a7865f44c120f7bf835a8c11c1914ffe483895acb449df189ba17f.jpeg",
    "https://cdn.faire.com/fastly/5937462a25d3295ddf73b59ea171b0e8c64ac7671843bb4ea1ae249ac79c4138.jpeg",
  ],
  priceDollars: 9,
  description:
    "A strong gift for nature lovers and a reliable evergreen reorder. Customers paint the cards themselves and send them — simple instructions included.\n\nIllustrations: hummingbird, robin, goldfinch, bluebird.\n\n$9 wholesale · $18 retail · set of eight notecards + envelopes\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:12.296Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
